<google-chart [data]="capacitacionByUserChart"></google-chart>